import { createContext, useContext, useMemo } from 'react';
import useGroupsIndex from './useGroupsIndex';

export const GroupContext = createContext();
export const useGroupContext = () => useContext(GroupContext);

const GroupProvider = ({ children }) => {
  const { groupList, groupMap, getGroup, search } = useGroupsIndex();

  const context = useMemo(() => {
    return {
      getGroup,
      groupList,
      groupMap,
      search,
    };
  }, [groupList, groupMap]);

  return (
    <GroupContext.Provider value={context}>{children}</GroupContext.Provider>
  );
};

export default GroupProvider;
